import { defineStore } from "pinia";
import { fetchFollowing, fetchFollowers, follow, unfollow } from '../services/achievementsService'
import { useAuthStore } from './auth';

import { type FollowingResponse } from '~/types';


type FollowType = {
	id: number;
	followable_type: string;
	followable_id: number;
	user_id: number;
	created_at: string;
	updated_at: string;
	created_at_formatted: string;
	created_at_diff: string;
	created_at_in_full: string;
	created_at_textual: string;
	updated_at_formatted: string;
	updated_at_diff: string;
	updated_at_in_full: string;
	updated_at_textual: string;
	content_type: string;
	followable: {
		id: number;
		api_id: number;
		name: string;
		url: string;
		slug: string;
		last_update: string;
		url_cover: string;
		url_banner: string;
		summary: string;
		clicks: number;
		views: number;
		collection_id: number;
		franchise_id: number;
		game_status_id: number;
		game_type_id: number;
		esports: boolean;
		popularity: string;
		rating: string;
		first_release_date: string;
		steam_id: number;
		created_at: string;
		updated_at: string;
		indie: boolean;
		localized_name: string;
		thumbnail_url: string;
		release_year: number;
		urls: Array<any>;
		rating_description: string;
		short_description: string;
		avg_rating: number;
		rating_stats: object;
		rating_hash: string;
		report_hash: string;
		first_release_date_formatted: string;
		first_release_date_diff: string;
		first_release_date_in_full: string;
		first_release_date_textual: string;
		created_at_formatted: string;
		created_at_diff: string;
		created_at_in_full: string;
		created_at_textual: string;
		updated_at_formatted: string;
		updated_at_diff: string;
		updated_at_in_full: string;
		updated_at_textual: string;
		user_is_following: boolean;
		follow_hash: string;
		content_type: string;
	},
	user: {
		id: number;
		uuid: string;
		name: string;
		nickname: string;
		avatar_url: string;
		short_bio: string;
		long_bio: string;
		country: {
			id: number;
			name: string;
			localized_name: string;
			language_id: 2,
			isocode: string;
			code2: string;
			code3: string;
			flag_url: string;
		},
		invite_qr_code: string;
		follow_hash: string;
		user_is_following: boolean;
		followers_count: number;
		following_count: number;
	}
}

export const useFollowingStore = defineStore({
	id: "following-store",
	state: () => {
		return {
			isFollowingOpened: <boolean>false,
			followingTab: <string>'',
			followings: {
				// data: [] as FollowingResponse[],
				data: [] as any,
				status: 'init'
			},
            followers: {
				// data: [] as FollowingResponse[],
				data: [] as any,
				status: 'init'
			},
			commonFollowStatus: 'init'
		}
	},
	actions: {
		showModalWithTab(param: string) {
			this.isFollowingOpened = !this.isFollowingOpened;
			this.followingTab = param;
		},
		closeModal(){
			this.isFollowingOpened = false;
		},
		async fetchFollowingList(params: any) {
			const authStore = useAuthStore()
			this.followings.status = "pending";
			const locale = useNuxtApp().$i18n.locale;;
			const nickname: string = authStore.user.nickname;

			try {
				let { data } = await fetchFollowing(locale.value, nickname, params)
				this.followings.data = data.data;
				this.followings.status = "init";
			} catch (error) {
				this.followings.status = "error";
			}
			
		},
		async fetchFollowersList(params: any) {
			const authStore = useAuthStore()
			this.followers.status = "pending";
			const locale = useNuxtApp().$i18n.locale;;
			const nickname: string = authStore.user.nickname;

			try {
				let { data } = await fetchFollowers(locale.value, nickname, params)
				this.followers.data = data.data;
				this.followers.status = "init";
			} catch (error) {
				this.followers.status = "error";
			}
		},
		async follow(params: any) {
			this.commonFollowStatus = "pending";
			const locale = useNuxtApp().$i18n.locale;;

			try {
				let { data } = await follow(locale.value, { follow_hash: params })
				this.followers.data = data.data;
				this.commonFollowStatus = "init";
			} catch (error) {
				this.commonFollowStatus = "error";
			}
		},
		async unfollow(params: any) {
			this.commonFollowStatus = "pending";
			const locale = useNuxtApp().$i18n.locale;;

			try {
				let { data } = await unfollow(locale.value, { follow_hash: params })
				this.followers.data = data.data;
				this.commonFollowStatus = "init";
			} catch (error) {
				this.commonFollowStatus = "error";
			}
		}
	},
	getters: {
		getFollowStatus: (state) => state.commonFollowStatus,
		getFollowingOpened: (state) => state.isFollowingOpened,
		getFollowingTab: (state) => state.followingTab,
		getFollowings: (state) => state.followings,
		getFollowers: (state) => state.followers,
	}
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useFollowingStore, import.meta.hot));
}